import React from 'react';
import { useStyles } from './Divider.styles';
var Divider = function () {
    var classes = useStyles();
    return React.createElement("div", { className: classes.divider });
};
export { Divider };
